/**
 * IDs de roles del sistema (tabla roles / user.role_id).
 * Mantener aquí todos los role_id usados en el front para evitar duplicar números mágicos.
 */

/** Administrador — permisos completos */
export const ROLE_ID_ADMIN = 1

/**
 * Rol 13: al crear una transferencia Flexy solo ve
 * origen Saldos, Devoluciones y Garantías;
 * destino Fulfillment, Xerox, Saldos, Devoluciones y Garantías.
 */
export const ROLE_ID_TRASLADO_BODEGAS_LIMITADAS = 13

/** Líder de ventas */
export const ROLE_ID_LIDER_VENTAS = 6

/** Mismo rol que líder: usuarios listables como «líder» al crear un agente */
export const ROLE_ID_LISTA_LIDERES_PARA_AGENTE = ROLE_ID_LIDER_VENTAS

/** Agente de ventas */
export const ROLE_ID_AGENTE_VENTAS = 7

/**
 * Rol operativo / manager Homecenter (id 16).
 * Pedidos: solo tienda Homecenter; lista de productos: bodega BHOMEC en lugar de XEROX.
 */
export const ROLE_ID_OPERACIONES = 16

/** Alias explícito para restricciones de UI Homecenter (mismo id que operaciones). */
export const ROLE_ID_MANAGER_HOMECENTER = ROLE_ID_OPERACIONES

/** Manager marketplace — solo tiendas ML, Falabella, Éxito */
export const ROLE_ID_MANAGER_MARKETPLACE = 17

/** Mismo filtro de tiendas marketplace que rol 17 */
export const ROLE_ID_MARKETPLACE_STORE_FILTER_25 = 25

/** Roles que solo ven / eligen Mercado Libre, Falabella y Éxito */
export const ROLE_IDS_MARKETPLACE_STORE_FILTER: readonly number[] = [
  ROLE_ID_MANAGER_MARKETPLACE,
  ROLE_ID_MARKETPLACE_STORE_FILTER_25,
] as const

/** Contabilidad — p. ej. devolución de dinero */
export const ROLE_ID_CONTABILIDAD = 19

/** Gestor de garantías — p. ej. devolución de dinero */
export const ROLE_ID_GESTOR_GARANTIAS = 21

/** Gerente de ventas — superior del líder en jerarquía de usuarios */
export const ROLE_ID_GERENTE_VENTAS = 24

/** Auxiliar Homecenter */
export const ROLE_ID_AUXILIAR_HOMECENTER = 26

/** Roles Homecenter con permiso de editar productos en pedidos restringidos */
export const ROLE_IDS_HOMECENTER_ORDER: readonly number[] = [
  ROLE_ID_OPERACIONES,
  ROLE_ID_AUXILIAR_HOMECENTER,
] as const

/** Roles incluidos en el select «Agente de ventas» del listado de pedidos */
export const ROLE_IDS_ORDER_SALES_AGENT_FILTER: readonly number[] = [
  ROLE_ID_AGENTE_VENTAS,
  ROLE_ID_LIDER_VENTAS,
  ROLE_ID_GESTOR_GARANTIAS,
] as const

const ORDER_SALES_AGENT_FILTER_ROLE_NAMES = new Set([
  'agente de ventas',
  'líder de ventas',
  'lider de ventas',
  'líder de marca',
  'lider de marca',
  'gestor de garantías',
  'gestor de garantias',
])

export function isHomecenterOrderRole(roleId: number | undefined | null): boolean {
  return roleId != null && ROLE_IDS_HOMECENTER_ORDER.includes(roleId)
}

/** Usuario visible en el select de filtro agente de ventas (lista de pedidos) */
export function userMatchesOrderSalesAgentFilter(user: {
  role_id: number
  role_name?: string
}): boolean {
  if (ROLE_IDS_ORDER_SALES_AGENT_FILTER.includes(user.role_id)) {
    return true
  }
  const roleName = (user.role_name || '').trim().toLowerCase()
  return ORDER_SALES_AGENT_FILTER_ROLE_NAMES.has(roleName)
}

/** Alias históricos (modales de usuarios) */
export const ID_AGENTE_VENTAS = ROLE_ID_AGENTE_VENTAS
export const ID_LIDER_VENTAS = ROLE_ID_LIDER_VENTAS
export const ID_ROL_LISTA_LIDERES_PARA_AGENTE = ROLE_ID_LISTA_LIDERES_PARA_AGENTE
export const ID_GERENTE_VENTAS = ROLE_ID_GERENTE_VENTAS

export const MANAGER_MARKETPLACE_ROLE_ID = ROLE_ID_MANAGER_MARKETPLACE
